import API from './API.js';
export default class Licenses extends API {
    constructor() {
        super('Library/licenses');
    }

}
